import { initializeEventTransformers } from './event-transformers.js'
import type { CartItemData, ElevarEcommerceItem } from 'types'

window.ElevarDataLayer = window.ElevarDataLayer ?? []

const pushToElevarDataLayer = (event: string, data: any) => {
  window.ElevarDataLayer.push({ event, ...data })
}

const buildElevarEcommerceItem = (item: CartItemData): ElevarEcommerceItem => ({
  id: item.sku,
  name: item.product_title,
  brand: item.vendor,
  variant: item.variant_title || 'Default',
  price: item.price,
  quantity: item.quantity,
  product_id: String(item.product_id),
  variant_id: String(item.variant_id),
})

const fetchElevarItemData = async (handle: string) => {
  try {
    const response = await fetch(`/products/${handle}?view=elevarItem`)
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching Elevar item data:', error)
    return null
  }
}

initializeEventTransformers()

export { pushToElevarDataLayer, buildElevarEcommerceItem, fetchElevarItemData }
